import type { ApiResponse } from '@neuroforge/shared'
import { api } from '@neuroforge/shared/client'

import { sessionTokenTag } from './auth-query-policy'

export interface AdminSessionUser {
  id: string
  role: string
  status: string
  emailVerified: boolean
}

export function adminSessionKey(id: string | undefined, token: string | null) {
  // Le token brut ne doit jamais figurer dans une clé de cache.
  return ['admin', 'session-check', id, sessionTokenTag(token)] as const
}

export async function fetchAdminSession(
  signal: AbortSignal,
): Promise<AdminSessionUser | undefined> {
  const response = await api.get<ApiResponse<AdminSessionUser>>('/auth/me', { signal })
  return response.data
}

export function isVerifiedAdmin(
  session: AdminSessionUser | undefined,
  expectedId: string,
): boolean {
  return (
    session?.id === expectedId &&
    session.role === 'ADMIN' &&
    session.status === 'ACTIVE' &&
    session.emailVerified === true
  )
}
